<template>
  <b-card>
      <b-button
        variant="primary"
        class="mb-1"
        @click="addNewDietTerm"
      >
        جدید
      </b-button>
      <b-table
        bordered
        hover
        striped
        responsive
        :items="items"
        :fields="fields"
        class="mt-1 mb-2 position-relative"
        :busy="loading"
        :no-local-sorting="true"
      >
        <template #cell(StartDate)="row">
          {{ row.value | date }}
        </template>
        <template #cell(EndDate)="row">
          {{ row.value | date }}
        </template>
        <template #cell(DietType)="row">
          {{ enums('DietType','value',row.value,'text') }}
        </template>
        <template #cell(IsDeactive)="row">
          <b-badge
            :variant="row.value ? 'warning' : 'success'"
          >
            {{ row.value ? 'غیر فعال' : 'فعال' }}
          </b-badge>
        </template>
        <template #cell(show_details)="row">
          <!--          <feather-icon-->
          <!--            :icon="row.detailsShowing? 'EyeOffIcon':'EyeIcon'"-->
          <!--            size="16"-->
          <!--            class="ml-1"-->
          <!--            @click="row.toggleDetails"-->
          <!--          />-->
          <feather-icon
            icon="EditIcon"
            size="16"
            class="ml-1"
            @click="editExpireDate(row)"
          />
          <feather-icon
            :icon="row.item.IsDeactive? 'CheckCircleIcon':'XCircleIcon'"
            size="16"
            class="ml-1 cursor-pointer"
            @click="suspendTerm(row.item)"
          />
        </template>
        <template #row-details="row">
          <b-card>
            <b-row class="mb-2">
              <b-col
                md="4"
                class="mb-1"
              >
                <strong>Full Name : </strong>{{ row.item.Id }}
              </b-col>
            </b-row>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="row.toggleDetails"
            >
              بستن
            </b-button>
          </b-card>
        </template>
      </b-table>
      <z-pagination
        :per-page="5"
        :page="filterOptions.Page"
        :total-rows="totalRows"
        :loading="loading"
        @change="dietOrders"
      />

    <b-modal
      v-model="showEditExpireDateModal"
      ok-only
      ok-title="ثبت"
      modal-class="modal-primary"
      centered
      title="تغییر تاریخ انقضا"
      @ok="changeExpireDate"
    >
      <b-card-text>
        <date-picker v-model="ExpireDate" />
      </b-card-text>
    </b-modal>
    <b-modal
      v-model="addNewTerm"
      ok-title="ثبت"
      cancel-title="انصراف"
      modal-class="modal-primary"
      centered
      title="ایجاد دوره جدید"
      :no-close-on-backdrop="true"
      @ok="saveNewTerm"
    >
      <b-card-text>
        <DietDurationPrice v-model="DietDurationPriceId " />
      </b-card-text>
    </b-modal>
  </b-card>
</template>
<script>
import DietDurationPrice from '@/tools/dietDurationPrice.vue'

export default {
  name: 'UserDietTerms',
  components: {
    DietDurationPrice,
  },
  props: {
    userId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      totalRows: 3,
      DietDurationPriceId: null,
      loading: false,
      ExpireDate: null,
      fields: [
        {
          key: 'StartDate',
          label: ' تاریخ شروع',
        },
        {
          key: 'EndDate',
          label: ' تاریخ پایان',
        },
        {
          key: 'DietType',
          label: 'متود',
        },
        {
          key: 'IsDeactive',
          label: 'وضعیت',
        },
        {
          key: 'UserDietOrderId',
          label: 'شماره سفارش',
        },
        {
          key: 'show_details',
          label: '',
          sortable: false,
        },
      ],
      items: [],
      addNewTerm: false,
      showEditExpireDateModal: false,
      filterOptions: {
        userId: this.userId,
        Page: 1,
        PerPage: 5,
      },
      row: null,
    }
  },
  created() {
    this.dietOrders()
  },
  methods: {
    changeExpireDate() {
      this.$http.post(this.$api.userDietTerms.update, {
        Id: this.row.Id,
        EndDate: this.ExpireDate,
        IsDeactive: this.row.IsDeactive,
      }).then(() => {
        this.dietOrders()
      })
    },
    saveNewTerm() {
      this.$http.post(this.$api.userDietTerms.add, {
        userId: this.userId,
        DietDurationPriceId: this.DietDurationPriceId,
      }).then(() => {
        this.dietOrders()
      })
    },
    addNewDietTerm() {
      this.addNewTerm = true
    },
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.dietOrders(1)
      }
    },
    dietOrders(pageNumber) {
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$http.post(this.$api.userDietTerms.get, this.filterOptions).then(res => {
        this.totalRows = res.totalRow
        this.items = res.data
      })
    },
    suspendTerm(row) {
      this.$bvModal.msgBoxConfirm(
        `آیا مطمئن هستید که می خواهید این ترم را
       ${this.enums('IsActive', 'value', row.IsDeactive, 'text')}
       کنید؟`, {
          title: 'حذف',
          size: 'sm',
          okVariant: 'danger',
          okTitle: `  ${this.enums('IsActive', 'value', row.IsDeactive, 'text')} شود`,
          cancelTitle: 'انصراف',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
          modalClass: 'modal-danger modal-remove-confirm',
        },
      )
        .then(confirm => {
          if (confirm) {
            this.$http.post(this.$api.userDietTerms.update, {
              Id: row.Id,
              EndDate: row.EndDate,
              IsDeactive: !row.IsDeactive,
            }).then(() => {
              this.dietOrders()
            })
          }
        })
    },
    editExpireDate(row) {
      this.row = row.item
      this.showEditExpireDateModal = true
    },
  },
}
</script>

<style scoped>

</style>
